const TrashIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6875 7.3125V11.8125M7.31253 7.3125V11.8125M15.1873 3.9375L2.81226 3.9375M14.0625 3.9375V14.625C14.0625 14.7742 14.0033 14.9173 13.8978 15.0227C13.7923 15.1282 13.6492 15.1875 13.5 15.1875H4.50003C4.35085 15.1875 4.20777 15.1282 4.10228 15.0227C3.99679 14.9173 3.93753 14.7742 3.93753 14.625V3.9375M11.8125 3.9375V2.8125C11.8125 2.51413 11.694 2.22798 11.483 2.017C11.272 1.80603 10.9859 1.6875 10.6875 1.6875H7.31253C7.01416 1.6875 6.72801 1.80603 6.51704 2.017C6.30606 2.22798 6.18753 2.51413 6.18753 2.8125V3.9375"
        stroke="#FF7A72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TrashIcon;
